import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, FormBuilder,ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;
// import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-admin-list',
	templateUrl: './admin-list.component.html',
	styleUrls: ['./admin-list.component.css']
})
export class AdminsListComponent implements OnInit {
	userList: any = [];
	selectedUser: any;
	isUpdateModalSelected: any;
	updateUserForm : FormGroup;
	countryList: any;
	languageList: any;
	selectedUserId: any;
	languageId: any;
	countryId: any;
	selectedUserData: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	isUserAvailable: boolean = true;
	time: any = 0;
	redirectUrl: any;
	activePageNo: number = 0;
	referer: string = '';
	is_group_users = false;
	group_id = false;
	prev_token = null;
	groupMemberList = [];
	prevUrl: any = null;
	from_group_list: any = false;
	mobile="[0-9]+";
	is_updated= false;
	selectedFile: File;
	adminProfile:string = '';
	is_super_admin:boolean;

	constructor(
		private commonService: CommonService,
		private authService: AuthService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private validationService: ValidationService,
		private pagerService: PagerService,
		private formBuilder: FormBuilder,
		// private http: HttpClient

	) {

		this.is_super_admin = JSON.parse(localStorage.getItem('is_super_admin'));
		if(this.is_super_admin==false){
			this.router.navigate(['/dashboard']);
			return;
		}


		this.activatedRoute.queryParamMap.subscribe(params => {
			if (params.get('type') && params.get('type') != undefined)
				this.time = params.get('type');
		});
		this.activatedRoute.params.subscribe(params => {
			if (params['group_id'] && params['group_id'] != undefined) {
				this.group_id = params['group_id'];
				this.is_group_users = true;
			}
			if (params['prev_token'] && params['prev_token'] != undefined) {
				this.prev_token = params['prev_token'];

				if (this.prev_token.indexOf("groupList") >= 0)
					this.from_group_list = true;
			}
			this.prevUrl = params.prev_token;
		});

		this.limit = 10;
		this.pageNo = 1;

		this.getAdminList(this.pageNo, this.limit, this.searchStr);
	}

	ngOnInit() {
		this.initializeUserList();
		this.commonService.process();
	}

	myClickFunction(pageNo) {
		if (pageNo == this.activePageNo) {
			this.router.navigate['/society-group-list/']
		}
	}

	initializeUserList() {

		$('.navbar-brand').text('Admin List');
		this.commonService.setTitle();

		this.updateUserForm = this.formBuilder.group({
            name: ['', Validators.required],
            user_name: ['', Validators.required],
            phone: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            country_id: ['', Validators.required],
			language_id: [false, Validators.required],
			is_super_admin : ['',null],
        });
		

		// Get Country List
		this.authService.getCountryList().subscribe(data => {
			if (data.success) {
				this.countryList = data.country;
			}
		});

		// Get Language List
		this.authService.getLanguageList().subscribe(data => {
			if (data.success) {
				this.languageList = data.language;
			}
		});

	}

	addModelOpen(){
		this.is_updated = false;
		this.updateUserForm.controls["password"].updateValueAndValidity();
		this.updateUserForm.controls["password"].setValidators(Validators.required);
		this.updateUserForm.reset();
	}

	getAdminList = function (pageNo, limit, searchStr) {
		
		this.commonService.process();
		this.authService.StatusadminList(pageNo, limit, searchStr, this.time, true).subscribe(data => {

			if (data.success) {
				var that = this;
				if (pageNo == this.activePageNo){
					jQuery("#search").val(that.searchStr);
					jQuery('#page_' + that.activePageNo).addClass('active');
					if (that.activePageNo == 1)
						jQuery('#first, #prev').addClass('disabled');
					else if (that.activePageNo == that.pager.totalPages)
						jQuery('#next, #last').addClass('disabled');
				}

				this.isUserAvailable = true;
				this.userList = data.users.docs;
				this.total = data.users.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = 'pageNo=' + pageNo + '&searchStr=' + searchStr;
			} else {
				this.isUserAvailable = false;
				this.userList = [];
			}

			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		jQuery('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page) {
				$(this).parent('li').removeClass('active');
			}
		});
		if (jQuery('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			jQuery('#first, #prev').removeClass('disabled');
		if (jQuery('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			jQuery('#next, #last').removeClass('disabled');
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		
	}

	// Update user functionality.
	updateSelectedUser = function (selectedUserData) {
		
		this.is_updated = true;
		this.selectedUserData = selectedUserData;
		this.selectedUserId = this.selectedUserData._id;
		// Set controls 

		this.updateUserForm.controls["password"].setValidators([]);
		this.updateUserForm.controls["password"].updateValueAndValidity();


		this.updateUserForm.controls['name'].setValue(this.selectedUserData.name);
		this.updateUserForm.controls['user_name'].setValue(this.selectedUserData.user_name);

		this.updateUserForm.controls['email'].setValue(this.selectedUserData.email);
		this.updateUserForm.controls['phone'].setValue(this.selectedUserData.phone);
		this.updateUserForm.controls['password'].setValue('');
		this.updateUserForm.controls['language_id'].setValue(this.selectedUserData.language_id._id);
		this.updateUserForm.controls['country_id'].setValue(this.selectedUserData.country_id._id);
		this.updateUserForm.controls['is_super_admin'].setValue(this.selectedUserData.is_super_admin ? true : false);

	

	}

	onSubmit = function (userData) {

		// Check form is valid or not.
		if (!this.updateUserForm.valid) {
			this.validationService.validateAllFormFields(this.updateUserForm);
			return;
		}

		this.commonService.process();

		if(!this.is_updated){

			if(this.adminProfile){
				userData['profile'] = this.adminProfile;
			}

			this.authService.addAdmin(userData, this.selectedUserId).subscribe(data => {
				
				this.commonService.hideProcess();
				if (data.success) {
					$("#profileImage").val(null); 
					this.updateUserForm.reset();
					this.adminProfile = '';
					this.getAdminList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
			});

		}else{
			
			userData['id'] = this.selectedUserId;
			if(this.adminProfile){
				userData['profile'] = this.adminProfile;
			}

			this.authService.updateAdmin(userData, this.selectedUserId).subscribe(data => {
				if (data.success) {
					$("#profileImage").val(null); 
					this.updateUserForm.reset();
					this.adminProfile = '';
					this.commonService.hideProcess();
					this.getAdminList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}else {
					this.commonService.hideProcess();
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
			});

		}
	
	}

	// Update user status
	updateUserStatus = function (userId) {
		this.authService.updateUserStatus(userId).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
				this.getAdminList(1, this.limit, this.searchStr);
			} else {
				$('#chk_' + userId).click();
				$('#chk_' + userId).is(':checked') ? $('#chk_' + userId).next('span.toggler').removeClass('off') : $('#chk_' + userId).next('span.toggler').addClass('off')
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	deleteAdmin = function (userId) {
		
		var x = confirm('Are you sure want to delete?');

		if(!x){
			return;
		}
		
		this.authService.deleteAdmin(userId).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
				this.getAdminList(1, this.limit, this.searchStr);
			} else {
				$('#chk_' + userId).click();
				$('#chk_' + userId).is(':checked') ? $('#chk_' + userId).next('span.toggler').removeClass('off') : $('#chk_' + userId).next('span.toggler').addClass('off')
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	upload(event){

		this.selectedFile = <File>event.target.files[0];
 		const fd = new FormData();
		fd.append('imageFile', this.selectedFile, this.selectedFile.name);

		this.authService.adminProfileUplod(fd).subscribe(Response => {
			if(Response.success){
				this.adminProfile = Response.data.path;
				console.log(this.adminProfile);
			}else{
				jQuery.growl.error({ title: 'Error', message: 'Please select valide file' });
			}
		});
	
	}

	  
	// Search user
	searchUser = function () {
		this.referer = '';
		this.searchStr = jQuery("#search").val();
		this.getAdminList(1, this.limit, this.searchStr);
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/admin-list/admin-list.component.ts